'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageHeader = require('./PageHeader');

Object.defineProperty(exports, 'PageHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PageHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/pageHeader/index.js
// module id = 588
// module chunks = 0